import { render, staticRenderFns } from "./LatestRidesSidebar.vue?vue&type=template&id=37e4ed46&scoped=true&"
import script from "./LatestRidesSidebar.vue?vue&type=script&lang=js&"
export * from "./LatestRidesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LatestRidesSidebar.vue?vue&type=style&index=0&id=37e4ed46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4ed46",
  null
  
)

export default component.exports